var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#8138DF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20921 15.7908C8.48816 16.0697 8.94042 16.0697 9.21936 15.7908L13.5051 11.5051C13.784 11.2261 13.784 10.7739 13.5051 10.4949L9.21936 6.20921C8.94042 5.93026 8.48816 5.93026 8.20921 6.20921C7.93026 6.48815 7.93026 6.94042 8.20921 7.21936L11.9898 11L8.20921 14.7806C7.93026 15.0596 7.93026 15.5118 8.20921 15.7908Z",
    fill: "#8138DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowRound);
export default __webpack_public_path__ + "static/media/right-arrow-round.8ffc5128a7b4caade997d0635f8f1123.svg";
export { ForwardRef as ReactComponent };